import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './styles.css';
import { AuthProvider, RequireAuth } from './auth';
import { Shell } from './components/Shell';
import { LoginPage } from './pages/Login';
import { TenantsPage } from './pages/Tenants';
import { TenantDetailPage } from './pages/TenantDetail';
import { ResultPage } from './pages/Result';
import { PortalPage } from './pages/Portal';
import { UsersPage } from './pages/Users';
import { HomePage } from './pages/Home';
import { ManagePage } from './pages/Manage';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public: no account needed anywhere in this block. */}
          <Route path="/" element={<HomePage />} />
          <Route path="/result/:id" element={<ResultPage />} />
          <Route path="/t/:slug" element={<PortalPage />} />
          <Route path="/t/:slug/manage" element={<ManagePage />} />
          <Route path="/login" element={<LoginPage />} />

          {/* Operator console, for whoever runs the instance. */}
          <Route element={<RequireAuth><Shell /></RequireAuth>}>
            <Route path="/admin" element={<TenantsPage />} />
            <Route path="/admin/tenants/:tenantId" element={<TenantDetailPage />} />
            <Route path="/admin/users" element={<UsersPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
